"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _excluded = ["width", "height", "color"];

var BookmarkOutline = function BookmarkOutline(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 24 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 24 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return (0, _preact.h)("svg", (0, _extends2.default)({
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: color,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _preact.h)("path", {
    d: "M11.334 2H4.66732C3.93398 2 3.34065 2.6 3.34065 3.33333L3.33398 14L8.00065 12L12.6673 14V3.33333C12.6673 2.6 12.0673 2 11.334 2ZM11.334 12L8.00065 10.5467L4.66732 12V3.33333H11.334V12Z",
    fill: "#5F6C7A"
  }));
};

var _default = BookmarkOutline;
exports.default = _default;